import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* addScreeningFeedback(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.SCREENING.ADD_HISTORY, action.payload, true);
}

export function* getScreeningHistory(action: any): any {
  const { screening_id, application_type } = action.payload;
  const queryParams =
    `?screening_id=${screening_id}` + (application_type ? `&application_type=${application_type}` : "");
  const url = `${API_URL.SCREENING.GET_HISTORY}${queryParams}`;
  yield call(sagaFunction, action, CallApi.GET, url, {}, true);
}

export function* updateScreeningStatus(action: any): any {
  // Expects payload: { screening_id: string, status: number }
  yield call(sagaFunction, action, CallApi.POST, API_URL.SCREENING.UPDATE_STATUS, action.payload, true);
}
